import { render, staticRenderFns } from "./wechatGroupShopListModal.vue?vue&type=template&id=331c77c4&scoped=true"
import script from "./wechatGroupShopListModal.vue?vue&type=script&lang=js"
export * from "./wechatGroupShopListModal.vue?vue&type=script&lang=js"
import style0 from "./wechatGroupShopListModal.vue?vue&type=style&index=0&id=331c77c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c77c4",
  null
  
)

export default component.exports